module.exports = {"150103001":"新华西路街道","150103002":"中山西路街道","150103003":"光明路街道","150103004":"海拉尔西路街道","150103005":"环河街街道","150103006":"通道街街道","150103007":"钢铁路街道","150103100":"攸攸板镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150103.json
// module id = 480
// module chunks = 0